// Import the Zod-derived type instead of duplicating

import type { TokenResponseItem } from "@/domains/validators/api-service/tokens"
import { LcAddress } from "@/domains/core"

import type { TokenStore } from "./token-store"

// API Response (raw from API)
export type TokenApiResponse = TokenResponseItem

// Provider-defined interfaces for token capabilities
// Consumers import and compose these interfaces as needed
export interface ITokenLookup {
  find(address: LcAddress): TokenStore | undefined
}

// Domain Data Transfer Object (normalized for internal use)
export type TokenApiDAO = {
  address: LcAddress
  symbol: string
  name: string
  decimals: number
  isWhitelisted: boolean
  isSwapToken: boolean
  isIncentiveToken: boolean
  tags: string[]
  priceUsd: string
}

export type TokenDiscoverer =
  | "token-api"
  | "classic-pools"
  | "system"
  | "minimal-pools"
  | "static-tokens"
  | "thick-v1"
  | "thick-v2"

export type TokenSource = "system" | "user"

export type GetTokenByFilter = {
  isSwapToken?: boolean
  isIncentiveToken?: boolean
  isWhitelisted?: boolean
  isSystemToken?: boolean
  isUserToken?: boolean
}

// Conversion function
export function convertApiResponseToTokenDAO(apiItem: TokenApiResponse): TokenApiDAO {
  return {
    address: new LcAddress(apiItem.address),
    symbol: apiItem.symbol,
    name: apiItem.name,
    decimals: apiItem.decimals,
    isWhitelisted: apiItem.isWhitelisted,
    isSwapToken: apiItem.isSwapToken,
    isIncentiveToken: apiItem.isBribeToken, // Map API's isBribeToken to frontend's isIncentiveToken
    tags: apiItem.tags,
    priceUsd: apiItem.priceUsd,
  }
}
